import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../../_services/alert.service";
import { environment } from "../../../../environments/environment";
import { ApiHttpService } from "../../../_services/api-http.service";
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';

const { API_URL } = environment;
@Component({
  selector: 'app-passportcheck-image',
  templateUrl: './passportcheck-image.component.html',
  styleUrls: ['./passportcheck-image.component.scss']
})
export class PassportcheckImageComponent implements OnInit {
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  orvreport: FormGroup;
  form: FormGroup;
  Resultdata: any;
  merchantId:any;
  pageSize: number = 10;
  private filterObj: any = {};
  SingleRow: any;
  currentPage: number = 0;
  collectionSize: number = 0;
  merchantdis: boolean = true;
  filedisFront: boolean = true;
  docerrorisFront: boolean = false;
  filedisBack: boolean = true;
  flagcheck:boolean=true;
  selectedFileFront:any;
  selectedFileBack:any;
  loading: boolean = false;
  modalConfigBlocked: ModalConfig;
  private specialKeys: Array<string> = [
    "Backspace",
    "Tab",
    "End",
    "Home",
    "-",
    "ArrowLeft",
    "ArrowRight",
    "Del",
    "Delete"
  ];
  @ViewChild('acc') private acc: NgbAccordion;
  private gridApi!: GridApi;
   //public rowData: any[];
  //public rowData: ColDef[] = [];
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };
  passportCheck:FormGroup;
  isForm2Submitted:boolean=false;
 
  public columnDefs: ColDef[] = [   
    { field: 'nameOncard', tooltipField: 'name', headerName: 'Name on Passport'},
    { field: 'passportNumber', tooltipField: 'passportNumber', headerName: 'Passport Number'},
    { field: "dob", tooltipField: 'dob', headerName: 'D.O.B' },
    { field: 'fileNumber',tooltipField: 'surname', headerName: 'File Number' },  
    { field: 'nationality', tooltipField: 'status', headerName: 'Nationality'}, 
  ];

rowData = [];




  tableSelectedColumn: ColDef[] = [...this.columnDefs];
  private responsePassport:any;
  constructor(private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService, ) {
 

    this.passportCheck = formBuilder.group({
      frontupload:["",Validators.required],
      backupload:[""]

      },    
    );
  }
    ngOnInit(): void {
     this.fetchPassportList();
     this.modalConfigBlocked = {
      modalTitle: "Document",
      modalSize: 'xl',
   
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    }
errormsg:any
    onSubmit(formvalue: any, type: any) {
      this.docerrorisFront=false
      this.isForm2Submitted=true;
      if(!this.passportCheck.valid){  
        this.filedisFront= false;
        this.filedisBack=false;
      }
      else{

       
        const formData = new FormData();
        formData.append('imageFront', this.selectedFileFront);
        formData.append('imageBack', this.selectedFileBack);
        this.filedisFront= true;
        this.filedisBack=true;
            this.loading = true;
            this.passportCheck.reset();
            document?.getElementById('submitloading')?.classList.add("spinner-border")
            document?.getElementById('submitloading')?.classList.add("spinner-border-sm")
            // this.apiHttpService.post(`${API_URL}/passport/${passportData.origin}/${passportData.name}/${passportData.passportNumber}/${passportData.dob}?pageSize=` + this.pageSize + '&page=' + (this.currentPage - 1), null).subscribe((data: any) => {
              this.apiHttpService.post(`${API_URL}/passport/image`,formData).subscribe((data: any) => {
                
             console.log("JSON.stringify(data)======"+JSON.stringify(data))                
               if(data[0]?.error){
                this.docerrorisFront=true;
                this.errormsg=data[0].error;
                this.alertService.errorsms(data[0].error);                
               }
               else{              
                 this.alertService.successAlert(data);                 
               }             
               setTimeout(() => { 
                this.fetchPassportList(); 
                this.loading = false;             
                document?.getElementById('submitloading')?.classList.remove("spinner-border");
                document?.getElementById('submitloading')?.classList.remove("spinner-border-sm");      
              },0);      
              }
              
              );      
        
  
    }
    }

    fetchPassportList(){
      debugger
      // this.apiHttpService.get(`${API_URL}/passport/verify/list?pageSize=` + this.pageSize + '&page=' + (this.currentPage - 1), null).subscribe((data: any) => {  
        this.apiHttpService.get(`${API_URL}/passport/verify/list/image`).subscribe((data: any) => {      
        this.collectionSize = data;
      this.rowData=data;   
        // alert("rowData====="+JSON.stringify(this.rowData))
        console.log("JSON.stringify(this.rowData)===="+JSON.stringify(this.rowData))
         })

    }
   
    file:any;  
    onFilterOpened(param: FilterOpenedEvent | any) {
      console.log("onFilterOpened----->", param);
    }
    onFilterModified(param: FilterModifiedEvent | any) {
      debugger
      const temp = param?.filterInstance;
      this.filterObj[param?.column?.colId] = temp;
    }
    onRowDoubleClicked(param: RowClickedEvent | any) {
      debugger
      let coldata=param.data;
     let merchant=coldata.merchantId;
      this.apiHttpService
      .post(
        `${API_URL}/docs/download/${coldata.merchantId}/OSV`, null
        )
      .subscribe((data) => (
       this.downloadPdf(data,merchant)
      ));
      param.node.setExpanded(!param.node.expanded);
    }
    downloadPdf(data:any,merchantdata:any) {
      const linkSource =
      'data:application/octet-stream;base64,' +data.text;
      const downloadLink = document.createElement('a');
      const fileName = merchantdata+'_OSV.pdf';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
    async onRowClicked(param: RowClickedEvent | any) {
      this.SingleRow = param.data
      console.log(this.SingleRow)
      alert("this.SingleRow=="+JSON.stringify(this.SingleRow))
    }
    onPageSizeChanges($event: Event) {
      this.apiHttpService
        .post(
          `${API_URL}/docs/fetchDocs/${this.pageSize}/${this.currentPage}?type=OSV`, null
          )
        .subscribe((data) => (
          //this.rowData = data.content?.data || Array.isArray(data.content) ? data.content: [],
          this.collectionSize = data.totalElements,
          this.gridApi.applyTransaction({ add: this.rowData })
        ));
    }
    onPaginationChange(param: PaginationChangedEvent | any) {
      debugger
      this.gridApi.paginationGoToPage(param - 1)
  
     }

     OnRowClicked(param: RowClickedEvent | any) {
      debugger
      this.SingleRow = param.data
          this.modalblockedComponent.open();  
  
    }

    onFileSelectedFront(event: Event): void {
      this.docerrorisFront=false
      this.filedisFront=true;
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFileFront = inputElement.files[0];
      }
        if( this.selectedFileFront.type !="jpg" ||  this.selectedFileFront.type !="jpeg" ||  this.selectedFileFront.type !="png" ){

        this.flagcheck=false
        this.filedisFront=true;
      }else{
        this.flagcheck=true
        this.filedisFront=false;
      }

    }

    onFileSelectedBack(event: Event): void {
      this.filedisBack=true;
      const inputElement = event.target as HTMLInputElement;
      if (inputElement.files && inputElement.files.length > 0) {
        this.selectedFileBack = inputElement.files[0];
      }
      if( this.selectedFileBack.type !="jpg" ||  this.selectedFileBack.type !="jpeg" ||  this.selectedFileBack.type !="png" ){
        this.flagcheck=false
        this.filedisBack=true;
      }else{
        this.flagcheck=true
        this.filedisBack=false;
      }

    }

    
  }